import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BestRoomPriceboxMobileComponent } from '../best-room-pricebox-mobile/best-room-pricebox-mobile.component';
import { LoaderDetailComponent } from '@commons/loader-detail/loader-detail.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'price-box-mobile',
    templateUrl: './price-box-mobile.component.html',
    styleUrls: ['./price-box-mobile.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        LoaderDetailComponent,
        BestRoomPriceboxMobileComponent,
    ],
})
export class PriceBoxMobileComponent implements OnInit {
  @Input()
  bestprice: any;
  @Input()
  busy: boolean;
  @Input()
  hotelStatic: any;
  @Input()
  bestAvailable: any;
  @Input()
  isLanding: boolean;
  @Input()
  priceByValue: string;
  @Input()
  showAmountTotal: boolean;
  @Input()
  isDisney: boolean;
  @Output()
  selectTab: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  public goToRoomsTab() {
    this.selectTab.emit(0);
  }
}
